module.exports = __webpack_public_path__ + "img/pizza-lab.845a70e7.png";